export default "__VITE_ASSET__BCog0pWK__"